import React, {useMemo, useState} from 'react';
import {
    MaterialReactTable,
    type MRT_ColumnDef,
    type MRT_ColumnFiltersState,
    MRT_EditActionButtons,
    type MRT_PaginationState,
    type MRT_Row,
    type MRT_SortingState,
    useMaterialReactTable,
} from 'material-react-table';
import {Box, Button, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Tooltip,} from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import AddDatiProg from "../../pages/gestdatiprog/AddDatiProg";
import {useDeleteDatiProg, useGetDatiProgDTO} from "./Services";
import EditDatiProg from "./EditDatiProg";
import {DatiProgDTO} from "./types";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import DatiProgExp from "./DatiProgExp";
import DashDatiProgetto from "../reportbi/DashDatiProgetto";
import {useTabSettings} from "../../common/Services";

interface ListaDatiProgProps {
  // propflgtemp: string;
}

const ListaDatiProg: React.FC<ListaDatiProgProps> = () => {
  const [validationErrors, setValidationErrors] = useState< Record<string, string | undefined>>({});
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>([],);
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({pageIndex: 0, pageSize: 15, });


    const [isDialogExporterOpen, setIsDialogExporterOpen] = useState(false);
    const [isDialogDatiProgDTOExpPDF, setIsDialogDatiProgDTOPDF] = useState(false);
    const [isDialogDatiProgDTOExpXLS, setIsDialogDatiProgDTOXLS] = useState(false);

   const [isDialogReportProgOpen, setIsDialogReportProgOpen] = useState(false);

   const role = localStorage.getItem('keyrole') || '';

   let isdatiprogettoadmin = false;

   if (role.includes('TimeReportAdmin') || role.includes('TimeReportDatiProgetto') ) {
       isdatiprogettoadmin = true;
   };



  const columns = useMemo<MRT_ColumnDef<DatiProgDTO>[]>(
  () => [
      // {
      //     accessorKey: 'ditta',
      //     header: 'Ditta',
      //     size: 5,
      //     enableEditing: false,
      // },
    {
      accessorKey: 'indclibloc',
      header: 'StatoCli',
      size: 5,
      enableEditing: false,
    },

    {
      accessorKey: 'codprog',
      header: 'CodProg',
      size: 5,
      enableEditing: false,
    },
    {
      accessorKey: 'desprog',
      header: 'DesProg',
      size: 5,
      enableEditing: false,
    },
    {
      accessorKey: 'statoprog',
      header: 'StatoProg',
      size: 5,
      enableEditing: false,
    },
    {
      accessorKey: 'flgcollord',
      header: 'FlagCollOrd',
      size: 5,
      enableEditing: false,
    },

    // { accessorKey: 'desprog', header: 'DesProg', size: 2, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 20 ? `${value.substring(0, 30)}...` : value}</span> ); }, },

    {
          accessorKey: 'dataagg',
          header: 'DataAgg',
          enableEditing: true,
          filterVariant: "date-range",
          size: 20,
          Cell: ({cell}) => {
              const value = cell.getValue();
              if (value && (typeof value === 'string' || typeof value === 'number' || value instanceof Date)) {
                  const date = new Date(value);
                  return new Intl.DateTimeFormat('it-IT', {day: '2-digit',  month: '2-digit', year: '2-digit' }).format(date);
              } else {
                  return '';
              }
          }
   },

    {
      accessorKey: 'ref',
      header: 'Ref',
      size: 5,
      enableEditing: false,
    },
    { accessorKey: 'refcli', header: 'RefCli', size: 2, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 20 ? `${value.substring(0, 20)}...` : value}</span> ); }, },

    {
      accessorKey: 'tipoprog',
      header: 'TipoProg',
      size: 5,
      enableEditing: false,
    },
     {
      accessorKey: 'tipomig',
      header: 'TipoMig',
      size: 5,
      enableEditing: false,
    },
    {
      accessorKey: 'tipoinst',
      header: 'TipoInst',
      size: 5,
      enableEditing: false,
    },
     {
      accessorKey: 'compprog',
      header: 'CompProg',
      grow: false,
      size: 5,
      enableEditing: false,
    },
     {
      accessorKey: 'flgtest',
      header: 'FlgEmailFatt',
      size: 5,
      enableEditing: false,
    },

    {
      accessorKey: 'flgdms',
      header: 'FlgDms',
      size: 5,
      enableEditing: false,
    },
    {
          accessorKey: 'datakickoffpian',
          header: 'KickPian',
          enableEditing: true,
          filterVariant: "date-range",
          size: 5,
          Cell: ({cell}) => {
              const value = cell.getValue();
              if (value && (typeof value === 'string' || typeof value === 'number' || value instanceof Date)) {
                  const date = new Date(value);
                  return new Intl.DateTimeFormat('it-IT', {day: '2-digit',  month: '2-digit', year: '2-digit' }).format(date);
              } else {
                  return '';
              }
          }
      },
      {
          accessorKey: 'datagolivepian',
          header: 'GoPian',
          enableEditing: true,
          filterVariant: "date-range",
          size: 5,
          Cell: ({cell}) => {
              const value = cell.getValue();
              if (value && (typeof value === 'string' || typeof value === 'number' || value instanceof Date)) {
                  const date = new Date(value);
                  return new Intl.DateTimeFormat('it-IT', {day: '2-digit',  month: '2-digit', year: '2-digit' }).format(date);
              } else {
                  return '';
              }
          }
      },
    {
          accessorKey: 'datapercomp',
          header: 'DtComp',
          enableEditing: true,
          filterVariant: "date-range",
          size: 5,
          Cell: ({cell}) => {
              const value = cell.getValue();
              if (value && (typeof value === 'string' || typeof value === 'number' || value instanceof Date)) {
                  const date = new Date(value);
                  return new Intl.DateTimeFormat('it-IT', {day: '2-digit',  month: '2-digit', year: '2-digit' }).format(date);
              } else {
                  return '';
              }
          }
      },
    {
      accessorKey: 'percomp',
      header: '%Comp',
      size: 5,
      enableEditing: false,
    },

      ],
 [validationErrors]
);

  const keyusername = localStorage.getItem('keyusername') || 'NN';
  const { columnVisibility, setColumnVisibility, saveTabSettings } = useTabSettings('ListaDatiProg', keyusername);
 const [draftColumnFilters, setDraftColumnFilters] = useState<MRT_ColumnFiltersState>(columnFilters);


  const { data: { results = [], count } = {}, isError: isLoadingDatiProgDTOError, isFetching: isFetchingDatiProgDTO, isLoading: isLoadingDatiProgDTO } = useGetDatiProgDTO(pagination, columnFilters, globalFilter, sorting);
  // const {  data: { results = [], count } = {} ,isError: isLoadingPrevTestaError, isFetching: isFetchingPrevTesta, isLoading: isLoadingPrevTesta, } = useGetAllDatiProg(pagination,columnFilters,globalFilter,sorting);
  const { mutateAsync: deleteDatiProg, isPending: isDeletingDatiProg } = useDeleteDatiProg();



  const [isDialogEditOpen, setIsDialogEditOpen] = useState(false);
  const [currentRowId, setCurrentRowId] = useState('0');
  const [isDialogAddOpen, setIsDialogAddOpen] = useState(false);


  const openDeleteConfirmModal = (row: MRT_Row<DatiProgDTO>) => {
    if (window.confirm('ATTENZIONE !!! CANCELLAZIONE DEL PROGETTO " '+row.original.codprog+' '+row.original.desprog+' "')) {
          deleteDatiProg(row.original.codprog? row.original.codprog : '' );
    }
  };


  const openAddModal = () => {
        setIsDialogAddOpen(true);
  };


  const openEditModal = (row: MRT_Row<DatiProgDTO>) => {
       setIsDialogEditOpen(true);
       setCurrentRowId(row.id);
   };

  const openReportProgModal = (row: MRT_Row<DatiProgDTO>) => {
    setIsDialogReportProgOpen(true);
    setCurrentRowId(row.id);
  };



  const table = useMaterialReactTable({
    columns,
    data: results,
    initialState: { density: 'compact' },

    manualFiltering: true, //turn off built-in client-side filtering
    manualPagination: true, //turn off built-in client-side pagination
    manualSorting: true, //turn off built-in client-side sorting

    createDisplayMode: 'modal', //default ('row', and 'custom' are also available)
    editDisplayMode: 'modal', //default ('row', 'cell', 'table', and 'custom' are also available)
    enableEditing: true,
    enableColumnActions: false,
    /*
    muiPaginationProps: {
      disabled: isFetchingDatiProg,
    },
    */

    //getRowId: (row) => row.id.toString(),

    getRowId: (row) => (row.id ? row.id : ''),



    muiToolbarAlertBannerProps: isLoadingDatiProgDTOError ? {
          color: 'error',
          children: 'Error loading data',
        } : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: '500px',
      },
    },
    // per compattazione tabella padding first above and below second left and right
     muiTableBodyCellProps: {
          sx: {
            padding: '0.5px 4px',
            fontSize: '.9rem',
          },
        },

     muiTableHeadCellProps: {
          sx: {
            padding: '0.5px 4px',
            fontSize: '0.9rem',
          },
        },
// fine compattazione vedi anche row actions


    // muiEditRowDialogProps: {
    //    fullWidth: true,
    //    maxWidth: 'md',
    //  },
    muiTableBodyRowProps: ({ row }) => {
            const { datagolivepian, percomp } = row.original;
            const isMissingRequiredFields =  datagolivepian === undefined || datagolivepian === null || percomp === null || percomp === undefined;
      return {
            sx: {
                backgroundColor: isMissingRequiredFields ? '#ffcccc' : 'inherit', // Light red background
            },
        };
    },

    // onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    // onPaginationChange: setPagination,
    // onSortingChange: setSorting,
    onCreatingRowCancel: () => setValidationErrors({}),
    onEditingRowCancel: () => setValidationErrors({}),

    onColumnFiltersChange: setDraftColumnFilters,
    // onColumnFiltersChange: (updater) => {
    //   const newFilters = typeof updater === 'function' ? updater(columnFilters) : updater;
    //   setColumnFilters(newFilters);
    //   saveTabSettings(columnVisibility, newFilters, sorting, pagination);
    // },
    onSortingChange: (updater) => {
      const newSorting = typeof updater === 'function' ? updater(sorting) : updater;
      setSorting(newSorting);
      saveTabSettings(columnVisibility, columnFilters, newSorting, pagination);
    },
    onPaginationChange: (updater) => {
      const newPagination = typeof updater === 'function' ? updater(pagination) : updater;
      setPagination(newPagination);
      saveTabSettings(columnVisibility, columnFilters, sorting, newPagination);
    },

    onColumnVisibilityChange: (updater) => {
      const newVisibility = typeof updater === 'function' ? updater(columnVisibility) : updater;
      setColumnVisibility(newVisibility);
      saveTabSettings(newVisibility, columnFilters, sorting,pagination);
    },


     renderCreateRowDialogContent: ({ table, row, internalEditComponents }) => (
         <>
        <DialogTitle variant="h3"  >Crea Nuovo </DialogTitle>
        <DialogContent
           sx={{ width: '1000px'}}
        >
          {internalEditComponents} {/* or render custom edit components here */}

        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>

       </>
    ),


   renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">Edit PrevTesta</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),

    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '0.20rem' }}>


       <Tooltip title="Modifica">
          <IconButton size="small"   onClick={() => openEditModal(row)} >
            <EditIcon sx={{ fontSize: 20 }}/>
          </IconButton>
        </Tooltip>

       {isDialogEditOpen && currentRowId === row.id && <EditDatiProg idprop={(currentRowId.trim())} onClose={()  => setIsDialogEditOpen(false) } />}

       <Tooltip title="Rimuovi">
          <IconButton size="small"  color="error"  onClick={() => openDeleteConfirmModal(row)} disabled={!isdatiprogettoadmin} >
            <DeleteIcon sx={{ fontSize: 20 }}/>
          </IconButton>
        </Tooltip>

       {/*<Tooltip title="ReportProgetto">*/}
       {/*   <IconButton color="info" onClick={() => openReportProgModal(row)}  >*/}
       {/*     <SummarizeIcon />*/}
       {/*   </IconButton>*/}
       {/* </Tooltip>*/}



        {isDialogReportProgOpen && currentRowId === row.id && (
          <DashDatiProgetto  codprogprop={(currentRowId.trim())}  desprogprop={row.original.desprog ? row.original.desprog : '' } onClose={() => setIsDialogReportProgOpen(false)} />
        )}



      </Box>


    ),


    renderTopToolbarCustomActions: ({ table }) => (
      <>

         <Stack
              direction="row"
              spacing={0}
              sx={{
                width: '60%',
                padding: '4px',
                alignItems: 'center',
              }}
            >


            <Box sx={{ width: '25%'}}>
                <Button
                    variant="contained"
                    onClick={openAddModal}
                    disabled={!isdatiprogettoadmin}
                    sx={{ width: 160 }}
                  >
                    Nuovo
                  </Button>
            </Box>

             {isDialogAddOpen && (<AddDatiProg onClose={() => {setIsDialogAddOpen(false); }}  /> )}

              <Box sx={{ width: '25%' }}></Box>

              <Box sx={{ width: '25%' }}>
                   <Button variant="contained" sx={{ width: 160 }} onClick={() => setIsDialogExporterOpen(true)} startIcon={<FileDownloadIcon />} > EXPORT DATI </Button>
                    {isDialogExporterOpen && (
                        <DatiProgExp
                          pagination={pagination}
                          columnFilters={columnFilters}
                          globalFilter={globalFilter}
                          sorting={sorting}
                          columnVisibility={columnVisibility}
                          columns={columns}
                          onClose={() => setIsDialogExporterOpen(false)}
                        />
                      )}
              </Box>

              <Box sx={{ width: '25%'}}>
                <Button
                  variant="contained"
                  onClick={() => {
                    setColumnFilters(draftColumnFilters);
                    saveTabSettings(columnVisibility, draftColumnFilters, sorting, pagination);
                  }}
                  sx={{ width: 160 }}
                >
                  Applica Filtri
                </Button>
              </Box>







                {/*<Box    sx={{        width: 20,         height: 20,          backgroundColor: '#ffcccc',          border: '1px solid #ccc',  }} >*/}
                {/*           <Typography variant="body2">Dati minimi mancanti </Typography>*/}
                {/*</Box>*/}

            </Stack>
  </>
),
      
      
      

    rowCount: count ?? 0,

    state: {
       isLoading: isLoadingDatiProgDTO,
       // isSaving: isCreatingDatiProgDTO || isUpdatingDatiProgDTO || isDeletingDatiProg,
       isSaving: isDeletingDatiProg,
       showAlertBanner: isLoadingDatiProgDTOError,
       showProgressBars: isFetchingDatiProgDTO,
      columnVisibility,
      columnFilters,
      globalFilter,
      pagination,
      sorting,
    },
  });

 return (
     <Box sx={{ mt: "60px" }}>
        <MaterialReactTable table={table} />
     </Box>
  );


};


export default ListaDatiProg;

